export const config = {
  supplyChainPolicy: {
    label: 'Supply Chain Policy',
    icon: "file-paper-2-line",
  },
  internalManagment: {
    label: 'Internal Management',
    icon: "layout-masonry-line",
  },
  supplyChainIntegrity: {
    label: 'Supply Chain Integrity',
    icon: "flow-chart",
  },
  supplierEngagement: {
    label: 'Supplier Engagement',
    icon: "contacts-book-2-line",
  },
  grievanceMechanism: {
    label: 'Grievance Mechanism',
    icon: "user-voice-line",
  },
};
